'use client'

import { CompaniesPage } from '@/widgets/companies-page'

export default function CompaniesPageRoute() {
  return <CompaniesPage />
}
